import React from 'react'

const DGCargoDetailsContext = React.createContext()

export default DGCargoDetailsContext
